<div class="block block-sidebar block-sidebar--offcanvas--mobile" [ngClass]="{
    'block-sidebar--open': isOpen
}">
    <div class="block-sidebar__body">
        <div class="block-sidebar__header">
            <div class="block-sidebar__title">Filters</div>
            <button class="block-sidebar__close" type="button" (click)="sidebar.close()">
                <app-icon name="cross-20" size="20"></app-icon>
            </button>
        </div>
        <div class="block-sidebar__item">
            <div class="widget-filters widget widget-filters--offcanvas--mobile" appCollapse>
                <h4 class="widget-filters__title widget__title">Filters</h4>
            
                <div class="widget-filters__list">
                    <div *ngFor="let filter of filters" class="widget-filters__item">
                        <div class="filter filter--opened" appCollapseItem="filter--opened" #collapse="appCollapseItem">
                            <button type="button" class="filter__title" (click)="collapse.toggle()">
                                {{ filter.name }}
                                <app-icon class="filter__arrow" name="arrow-rounded-down-12x7" size="12x7"></app-icon>
                            </button>
                            <div class="filter__body" appCollapseContent>
                                <div class="filter__container">
                                    <div *ngIf="filter.name === 'Category'" class="filter-categories" [ngClass]="{'filter-categories--root': filter.root}">
                                        <ul class="filter-categories__list">
                                            <li *ngIf="!filter.root" class="filter-categories__item filter-categories__item--parent">
                                                
                                                <a [routerLink]="this.root.shop()">All Categories</a>
                                            </li>
                                            <li *ngFor="let item of filter.items" class="filter-categories__item filter-categories__item--{{ item.type }}">
                                                 <a [routerLink]="'/shop/'+item.slug">{{ item.name }}</a>
                                                <div class="filter-categories__counter">{{ item.products }}</div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div *ngIf="filter.name === 'Brand'" class="filter-categories" [ngClass]="{'filter-categories--root': filter.root}">
                                        <ul class="filter-categories__list">
                                            <li *ngIf="!filter.root" class="filter-categories__item filter-categories__item--parent">
                                                
                                                <a [routerLink]="['/brands']">All Brands</a>
                                            </li>
                                            <li *ngFor="let item of filter.items" class="filter-categories__item filter-categories__item--{{ item.type }}">
                                                 <a [routerLink]="'/brands/'+item.slug">{{ item.name }}</a>
                                             
                                            </li>
                                        </ul>
                                    </div>
                                    <div *ngIf="filter.name === 'Tag'" class="filter-categories" [ngClass]="{'filter-categories--root': filter.root}">
                                        <ul class="filter-categories__list">
                                
                                            <li *ngFor="let item of filter.items" class="filter-categories__item filter-categories__item--{{ item.type }}">
                                                 <a [routerLink]="'/tags/'+item.slug">{{ item.name }}</a>
                                             
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
